import { render, staticRenderFns } from "./locationInfoCollection.vue?vue&type=template&id=0da28668&scoped=true"
import script from "./locationInfoCollection.vue?vue&type=script&lang=js"
export * from "./locationInfoCollection.vue?vue&type=script&lang=js"
import style0 from "./locationInfoCollection.vue?vue&type=style&index=0&id=0da28668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da28668",
  null
  
)

export default component.exports